<template>
  <div class="relative layout-contacts-map">
    <div
      class="overflow-hidden rounded-md bg-light map"
      :class="[
        aspect === 'square' ? 'aspect-square' : aspect === 'small-video' ? 'aspect-small-video' : 'aspect-video'
      ]"
    ></div>
    <div class="flex items-start pointer-events-none abs">
      <div class="relative p-4 m-2 text-left bg-white rounded-md pointer-events-auto w-80 ui-scroll" v-if="openedItem">
        <div @click="close" class="absolute cursor-pointer close right-4 top-4"><icon-close></icon-close></div>
        <div class="text-lg font-semibold uppercase">{{ openedItem.title }}</div>
        <div class="mb-2 text-base font-medium">{{ openedItem.desc }}</div>
        <div v-if="openedItem.phones">
          <a
            :href="`tel:${phone}`"
            v-for="(phone, index) in openedItem.phones"
            class="flex items-center gap-2 font-medium cursor-pointer"
            :key="index"
          >
            <icon-phone class="w-auto h-4"></icon-phone>
            {{ phone }}
          </a>
        </div>
        <div
          class="mt-4 text-base font-medium [&_a]:underline html"
          v-if="openedItem.html"
          v-html="openedItem.html"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    aspect: {
      type: String,
      default: 'square'
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      map: null,
      openedItem: null
    }
  },
  components: {
    IconClose: () => import('@/components/icon/icon-close.vue'),
    IconPhone: () => import('@/components/icon/icon-phone.vue')
  },
  methods: {
    close() {
      this.openedItem = null
    },
    initMap() {
      ymaps.ready(async () => {
        const map = await new ymaps.Map(this.$el.querySelector('.map'), {
          center: [55.76, 37.64],
          zoom: 7
        })
        this.map = map
        this.placeItemsOnMap()
      })
    },
    placeItemsOnMap() {
      this.items.forEach(item => {
        const { position } = item
        const placemark = new ymaps.Placemark(position)
        placemark.events.add('click', () => {
          this.openedItem = item
        })
        this.map.geoObjects.add(placemark)
      })
    }
  },
  mounted() {
    this.initMap()
  }
}
</script>

<style>
.layout-contacts-map .html a {
  text-decoration: underline;
}
</style>
